import { Ghost } from '@y2/mango/components/ghost';
import range from 'lodash/range';
import cn from 'classnames';
import styles from './item/mobile-list-item.module.scss';

type Props = {
  size: number;
  className?: string;
};

export function MobileListSkeleton({ size, className }: Props) {
  return (
    <ul className={className}>
      {range(size).map((index) => (
        <li key={index} className={styles.item}>
          <div className={styles.row}>
            <Ghost width={150} />
            <Ghost width={100} />
          </div>
          <div className={cn(styles.row, styles.smallText)}>
            <Ghost width={200} />
            <Ghost width={50} />
          </div>
        </li>
      ))}
    </ul>
  );
}
